import { render, staticRenderFns } from "./doclist.vue?vue&type=template&id=fbc3cdda&scoped=true"
import script from "./doclist.vue?vue&type=script&lang=js"
export * from "./doclist.vue?vue&type=script&lang=js"
import style0 from "./doclist.vue?vue&type=style&index=0&id=fbc3cdda&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc3cdda",
  null
  
)

export default component.exports